import { useMemo } from 'react';
import classNames from 'classnames';
import { useStrapiGlobal } from '@/context';
import { Link } from 'react-router-dom';

type FooterBottomProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer__bottom';

export const FooterBottom = ({ className }: FooterBottomProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const { layout } = useStrapiGlobal();
	const { footer } = layout;
	const { bottom } = footer;
	const { copyright, legalList, ctLogo } = bottom;

	return (
		<footer className={wrapperClassName}>
			<div className={`${classNameComponent}-content`}>
				<div className={`${classNameComponent}-row`}>
					<p className={`${classNameComponent}-copyright`}>{copyright}</p>
					<ul className={`${classNameComponent}-list`}>
						{legalList.map((it: { id: number; text: string; url: string }) => (
							<li key={it.id} className={`${classNameComponent}-list-item`}>
								<Link to={it.url}>
									<span>{it.text}</span>
								</Link>
							</li>
						))}
					</ul>
					<img className={`${classNameComponent}-ctlogo`} src={ctLogo.url} alt={ctLogo.alt} />
				</div>
			</div>
		</footer>
	);
};
